import React from "react";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import DeviceTypeForm from "../_forms/DeviceTypeForm";
import {modalActions} from "../../../../actions/modal.actions";
import {deviceTypeActions} from "../../../../actions/device-type.actions";
import {claimTypes} from "../../../../constants/claim.constants";

const DeviceTypeTable = ({t, list, user, showModal, hideModal, editDeviceType, deleteDeviceType}) => {

    const deviceTypeCrud = user[`c_device-type.actions.crud`] || null;

    const onEditModal = (row) => {
        showModal({
            open: true,
            title: t('edit_device-type'),
            component: <DeviceTypeForm data={row} submit={handleSubmitEditForm}/>,
        }, 'formModal');
    };

    const handleSubmitEditForm = (data) => {
        editDeviceType(data);
    };

    const onDeleteModal = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                deleteDeviceType(row.id);
                hideModal();
            },
        }, 'confirm')
    };

    // const onClickEditScript = (data) => {
    //     console.log(data)
    // };

    const columns = [
        {
            Header: '#',
            accessor: 'id',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
        },
        {
            Header: 'label',
            Cell: (props) => {
                const data = props.row.original;
                return (<b>{data.label}</b>)
            }
        },
        {
            Header: 'default-port',
            accessor: 'port',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
        },
        {
            Header: 'rabbitRoutingKey',
            accessor: 'rabbitRoutingKey',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
        },
        {
            Header: 'TCP/UDP',
            accessor: 'communicationProtocol',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    data.communicationProtocol ? data.communicationProtocol : "Brak"
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            show: deviceTypeCrud === claimTypes.READ_WRITE,
            Cell: (props) => {
                const data = props.row.original;
                return (
                    deviceTypeCrud === claimTypes.READ_WRITE ? (
                        <ButtonGroup>
                            <Button className="mx-1" variant={"primary"} onClick={() => onEditModal(data)}>
                                <i className="fas fa-edit" />
                            </Button>

                            <Button className="mx-1" variant={"danger"} onClick={() => onDeleteModal(data)}>
                                <i className="fas fa-trash" />
                            </Button>
                        </ButtonGroup>
                    ) : (t('msg.not-permission'))
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('device-type-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
      <div className="col-md-12 mx-0 my-3 p-0">
          {tableResult}
      </div>
    )

};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
    editDeviceType: (deviceTypeModel) => dispatch(deviceTypeActions.editDeviceType(deviceTypeModel)),
    deleteDeviceType: (deviceTypeId) => dispatch(deviceTypeActions.deleteDeviceType(deviceTypeId)),
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(DeviceTypeTable));
